export default class Model {}
